import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

@Component({
  selector: 'app-view-alert-details',
  templateUrl: './view-alert-details.component.html',
  styleUrls: ['./view-alert-details.component.scss'],
})
export class ViewAlertDetailsComponent {
  title: string;
  readonly LANG_CONST = LANG_CONST;

  constructor(
    public dialogRef: MatDialogRef<ViewAlertDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private stateManagementService: StateManagementService,
  ) {
    this.title = data?.title;
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }
  /**
   * @description #navigateToKwikset function opens the new tab of kwiksetunite page.
   * @returns void
   */
  navigateToKwikset(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.HELP_LINK_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.HELP_LINK_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.HELP_LINK, '_blank');
    }
  }
}
